<template>
    
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">close</a>
                        </section>
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{isFailRefund ? $t('1194') : $t('1132')}}
                                <!-- 환불 요청 -->
                            </div>                
                        </section>
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                </header>
                <section class="flex-grow-1 scroll-y">
                    <div class="pda-default">
                        <div class="t-headline10">
                            {{isFailRefund ? $t('1195') : $t('1133')}}
                                <!-- 환불 요청 정보 입력 / 계좌 정보 입력 -->
                        </div>
                        <div class="t-body3 t-color-content1 mgt-6 mgb-35">
                            {{isFailRefund ? $t('1196') : $t('1134')}}
                            <!-- 상품 환불 요청을 위해 아래의 정보를 입력하세요. / 환불 금액을 입금받을 계좌 정보를 입력하세요.-->
                        </div>
                        <div v-if="!isFailRefund">
                            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" 
                                id="inputReason">
                                <input type="text" class="mdc-text-field__input"
                                    name="refundReason"
                                    v-model="refundReason"
                                >
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                    <label for="tf-outlined" class="mdc-floating-label">
                                        {{$t('1135')}}
                                        <!-- 환불 요청 사유(최대 200자) -->
                                    </label>
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                            </div>
                            <hr class="divider mgt-16">
                        </div>

                        <div class="mgt-16 t-body3 t-color-content1">
                            {{$t('1136')}}
                            <!-- 환불 승인 시 금액을 입금받을 계좌 정보를 입력하세요. -->
                        </div>

                        <div class="mgt-16">
                            <div class="mdc-select mdc-select--outlined w-full" id="selectNation">
                                <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                                <select class="mdc-select__native-control" name="store" v-model="refundNation">
                                    <option  value="">
                                        {{$t('1137')}}
                                        <!-- 국가 -->
                                    </option>
                                    
                                </select>
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                            </div>
                        </div>

                        <div class="mgt-16">
                            <div class="mdc-select mdc-select--outlined w-full" id="selectBankCode">
                                <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                                <select class="mdc-select__native-control" name="store" v-model="refundBankCode">
                                    <option  value="">
                                        {{$t('1138')}}
                                        <!-- 은행 -->
                                    </option>
                                    <option v-for="(bank, index) in bankList" :key="index" :value="bank.key">
                                        {{bank.text}}
                                    </option>
                                    
                                </select>
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                        <!-- <label class="mdc-floating-label"></label> -->
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                            </div>
                            
                        </div>

                        <div class="mgt-16">
                            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" id="inputNumber">
                                <input type="text" class="mdc-text-field__input"
                                    name="refundNumber"
                                    v-model="refundNumber"
                                >
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                    <label for="tf-outlined" class="mdc-floating-label">
                                        {{$t('1139')}}
                                        <!-- 계좌 번호 -->
                                    </label>
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                            </div>
                        </div>

                        <div class="mgt-16">
                            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" id="inputName">
                                <input type="text" class="mdc-text-field__input"
                                    name="refundName"
                                    v-model="refundName"
                                >
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                    <label for="tf-outlined" class="mdc-floating-label">
                                        {{$t('1140')}}
                                        <!-- 예금주 -->
                                    </label>
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                            </div>
                        </div>

                        <div class="mgt-50">
                            <button class="mdc-button mdc-button--raised btn-red" @click="requestRefund()" :disabled="!checkValid">
                                {{$t('1141')}}
                                <!-- 완료 -->
                            </button>
                            <button class="mdc-button btn-white mgr-8 mgl-8" type="button" @click="cancelRefund()">
                                {{$t('1142')}}
                                <!-- 취소 -->
                            </button>
                        </div>

                    </div>
                    
                </section>
                
            </div>
        </div>
    </div>

</template>

<script>
/**
 * 멤버십 - 구매 상세 환불요청 컴포넌트(membership - purchase question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select'
import {MDCTextField} from '@material/textfield'
import salesApi from '@/api/salesApi.js'
export default {
    data() {
        return {
            orderId: '',

            refundCode: '',
            orderStatus: '',
            selectNation: null,
            selectBankCode: null,
            inputReason: null,
            inputNumbert: null,
            inputName: null,

            refundNation: '',
            refundReason: '',
            refundBankCode: '',
            refundNumber: '',
            refundName: '',

            bankList: [],
        }
    },

    mounted() {
        this.orderId = this.$route.params.orderId

        this.selectNation = new MDCSelect(document.querySelector('#selectNation'))
        this.selectNation.useNativeValidation = false
        this.selectBankCode = new MDCSelect(document.querySelector('#selectBankCode'))
        this.selectBankCode.useNativeValidation = false
        
        if (!this.isFailRefund) {
            this.inputReason = new MDCTextField(document.querySelector('#inputReason'))
            this.inputReason.useNativeValidation = false
        }

        this.inputNumber = new MDCTextField(document.querySelector('#inputNumber'))
        this.inputNumber.useNativeValidation = false

        this.inputName = new MDCTextField(document.querySelector('#inputName'))
        this.inputName.useNativeValidation = false

        let params = {
            orderId: this.$route.params.orderId
        }
        // get order information
        salesApi.salesOrderDetail(params).then((response) => {
            let orderData = response.data.data
            console.log('orderData', orderData);
            
            this.refundCode = orderData.refundCode
            this.refundReason = orderData.refundRequestReason
            this.orderStatus = orderData.status.value
            if (orderData.refundAccount) {
                this.refundBankCode = orderData.refundAccount.bank.key
                this.refundNumber = orderData.refundAccount.number
                this.refundName = orderData.refundAccount.name

                
                this.inputNumber.value = this.refundNumber
                this.inputName.value = this.refundName
            }

            this.inputReason.value = this.refundReason

        }).catch((err) => {

        })
        
        //환불 은행 목록(get refund bank list)
        salesApi.salesRefundBankList().then((response) => {
            this.bankList = response.data.data
        })
        
    },

    computed: {
        // 유효성 체크(validation check)
        checkValid() {
            if (this.orderStatus === 'FAIL_REFUND') {
                return !!(this.refundBankCode && this.refundNumber && this.refundName)
            }else {
                return !!(this.refundReason && this.refundBankCode && this.refundNumber && this.refundName)
            }
            
        },

        isFailRefund() {
            return this.orderStatus === 'FAIL_REFUND' ? true : false
        }
    },

    methods: {
        // 환불 요청 취소(cancel refund request)
        cancelRefund() {
            this.$router.go(-1)            
        },

        // 환불 요청(request refund)
        requestRefund() {
            let params = {
                orderId: this.orderId,
                reason: this.refundReason,
                account : {
                    bankCode: this.refundBankCode,
                    number: this.refundNumber,
                    name: this.refundName,
                },
                code: this.refundCode
            }

            let alertData = ''
            if (this.orderStatus === 'FAIL_REFUND') {
                alertData = {
                    title: this.$t('1143'), //계좌 정보가 저장되었습니다.
                    content: this.$t('1205') + ' ' + this.$t('1206') , //'입력된 계좌 정보가 저장되었습니다. 관리자가 확인 후 환불 금액이 개별 송금될 예정입니다.
                    accept: this.$t('1207'), //'확인',
                    
                }
            } else {
                alertData = {
                    title: this.$t('1204'), //환불 요청이 완료되었습니다
                    content: this.$t('1144') + ' ' + this.$t('1145') , //'관리자가 환불 승인 시 환불 처리가 시작됩니다. 환불 요청이 관리자에 의해 반려될 수 있습니다.
                    accept: this.$t('1146'), //'닫기',
                    
                }
            }

            if (this.refundCode) {
                // update refund
                salesApi.selesRefundUpdate(params).then((response) => {
                    // this.$router.go(-1)
                    this.$alert(alertData).then(() => {
                        this.$router.go(-1)
                    })
                })
            } else {
                // request refund
                salesApi.selesRefundRequest(params).then((response) => {
                    // this.$router.go(-1)
                    this.$alert(alertData).then(() => {
                        this.$router.go(-1)
                    })
                })
            }
            
        }
    }
}
</script>